<template>
  <div>

    <v-dialog
      v-model="dialog"
      max-width="350"
    >
      <v-card class="pa-5">
        <h3>Děkujeme za zprávu</h3>
        <p class="my-5">Formulář byl odeslán.</p>
        <div class="d-flex justify-center">
          <v-btn
            variant="flat"
            color="#f2cb45"
            @click="dialog = false"
          >OK</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <form @submit.prevent="submitForm">
      <h2>Kontaktní formulář</h2>
      <v-text-field
        label="Jméno"
        variant="solo"
        v-model="personalName"
        :error-messages="getViolation('personalName')"
      ></v-text-field>

      <v-text-field
        label="E-mail"
        variant="solo"
        v-model="email"
        :error-messages="getViolation('email')"
      ></v-text-field>

      <v-text-field
        label="Telefon"
        variant="solo"
        v-model="phone"
        :error-messages="getViolation('phone')"
      ></v-text-field>

      <v-textarea
        label="Zpráva"
        variant="solo"
        v-model="body"
        :error-messages="getViolation('body')"
      ></v-textarea>

      <!-- Honeypot: off-screen, real visitors never fill it, bots that fill every input do. -->
      <div style="position: absolute; left: -9999px; top: -9999px;" aria-hidden="true">
        <label>Website <input v-model="website" type="text" name="website" tabindex="-1" autocomplete="off"></label>
      </div>

      <div>
        <v-btn
          :loading="loading"
          :disabled="loading"
          variant="flat"
          color="#f2cb45"
          type="submit"
        >spojit se s námi</v-btn>
      </div>
    </form>

  </div>
</template>

<script>
import Axios from '../ajax'
import Qs from 'qs'
import { errorMixin } from '../mixins/error-mixin'

export default {
  name: 'VContactForm',
  data () {
    return {
      loading: false,
      personalName: '',
      email: '',
      phone: '',
      body: '',
      website: '',
      dialog: false, // Add this line for dialog control
    }
  },
  mixins: [
    errorMixin
  ],
  methods: {
    async submitForm () {
      // A second click or Enter while the request runs would send a duplicate inquiry.
      if (this.loading) return
      this.clearViolations()
      this.loading = true
      try {
        await Axios.post('/contact', Qs.stringify({
          personalName: this.personalName,
          email: this.email,
          phone: this.phone,
          body: this.body,
          website: this.website
        }))
        // Reset form fields after successful submission
        this.personalName = ''
        this.email = ''
        this.phone = ''
        this.body = ''
        // Show the dialog
        this.dialog = true
      } catch (err) {
        this.buildViolations(err.response)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
